(function (root) {
  'use strict';

  function readConfig() {
    var document = root.document;
    var element = document ? document.getElementById('ProductCostingConfig') : null;

    if (!element) {
      return null;
    }

    try {
      var config = JSON.parse(element.textContent || '{}');
      return config && typeof config === 'object' ? config : null;
    } catch (error) {
      return null;
    }
  }

  function configStatus(config) {
    if (!config) {
      return 'CONFIGURAZIONE_NON_TROVATA';
    }

    if (!root.ProductCostCalculator) {
      return 'CALCOLATORE_NON_CARICATO';
    }

    try {
      root.ProductCostCalculator.validateConfig(config);
      return 'OK';
    } catch (error) {
      return 'CONFIGURAZIONE_NON_COMPATIBILE';
    }
  }

  function updateStatus(api) {
    api.status = configStatus(api.config);
    api.ready = api.status === 'OK';
    return api.ready;
  }

  var api = root.ProductCosting || {};

  api.config = readConfig();
  updateStatus(api);

  api.reloadConfig = function () {
    api.config = readConfig();
    updateStatus(api);
    return api.config;
  };

  api.getConfig = function () {
    return api.config;
  };

  api.calculate = function (input, modelId) {
    if (!api.ready) {
      return {
        status: api.status
      };
    }

    try {
      return root.ProductCostCalculator.calculateProductCost(input || {}, api.config, modelId);
    } catch (error) {
      return {
        status: 'ERRORE_CALCOLO',
        message: error && error.message ? error.message : String(error)
      };
    }
  };

  root.ProductCosting = api;
})(typeof window !== 'undefined' ? window : this);
